var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBoxWithArrow(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "17px",
    height: "17px",
    viewBox: "0 0 17 17",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Shape") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Symbols",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Button/Export",
    transform: "translate(-23.000000, -12.000000)",
    fill: "#FFFFFF",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(0.307368, 0.500000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M38.8177079,19.5600693 C38.9344243,19.6767252 39,19.8349809 39,20 C39,20.1650191 38.9344243,20.3232748 38.8177079,20.4399307 L36.1276031,23.1300356 C35.8845436,23.3724619 35.4910584,23.3722053 35.2483152,23.1294622 C35.0055721,22.886719 35.0053155,22.4932338 35.2477418,22.2501742 L36.875564,20.6222222 L31.3465277,20.6222222 C31.0028839,20.6222222 30.7243055,20.3436438 30.7243055,20 C30.7243055,19.6563562 31.0028839,19.3777778 31.3465277,19.3777778 L36.875564,19.3777778 L35.2477418,17.7498258 C35.0053155,17.5067662 35.0055721,17.113281 35.2483152,16.8705378 C35.4910584,16.6277947 35.8845436,16.6275381 36.1276031,16.8699644 L38.8177079,19.5600693 Z M23.6222222,28 L32.5999997,28 C32.943624,28 33.2222219,27.7214021 33.2222219,27.3777778 L33.2222219,24.3121529 C33.2222219,23.968509 32.9436435,23.6899307 32.5999997,23.6899307 C32.2563559,23.6899307 31.9777775,23.968509 31.9777775,24.3121529 L31.9777775,26.7555556 L24.2444444,26.7555556 L24.2444444,13.2444444 L31.9777775,13.2444444 L31.9777775,15.6878471 C31.9777775,16.031491 32.2563559,16.3100693 32.5999997,16.3100693 C32.9436435,16.3100693 33.2222219,16.031491 33.2222219,15.6878471 L33.2222219,12.6222222 C33.2222219,12.2785979 32.943624,12 32.5999997,12 L23.6222222,12 C23.2785979,12 23,12.2785979 23,12.6222222 L23,27.3777778 C23,27.7214021 23.2785979,28 23.6222222,28 Z",
    id: "Shape",
    transform: "translate(31.000000, 20.000000) rotate(-90.000000) translate(-31.000000, -20.000000) "
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBoxWithArrow);
export default __webpack_public_path__ + "static/media/box-with-arrow.05c0bfe6ab8aea63bc1919436729b558.svg";
export { ForwardRef as ReactComponent };